// extracted by mini-css-extract-plugin
module.exports = {"container":"details_container_1d2Iv","description":"details_description_3lNya","lore":"details_lore_1no_x"};